<template>
	<div class="w-full">
		<div
			class="relative flex h-[380px] flex-col items-center overflow-clip bg-gradient-to-r from-[#006BAA] to-[#00A1FF] md:h-[180px] md:flex-row lg:flex-row xl:h-[200px]"
			:class="isPartner ? whitelabel.styles.bg.borderRadius : 'rounded'"
		>
			<!-- set 1 -->
			<div class="absolute -left-[50px] -top-[50px] flex h-full w-full">
				<div class="slide-in-out absolute -left-[40px] w-full">
					<div
						class="h-[280px] w-[200px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00FFF9] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>
				<div
					class="slide-in-out delay-2 absolute left-[280px] top-[0px] w-full"
				>
					<div
						class="h-[380px] w-[80px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00BBFF] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>
				<div
					class="slide-in-out-reverse delay-1 absolute left-[150px] top-[80px] w-full"
				>
					<div
						class="h-[280px] w-[120px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00375F] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>
				<div
					class="slide-in-out-reverse delay-3 absolute left-[320px] top-[100px] w-full"
				>
					<div
						class="h-[280px] w-[90px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00FFF9] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>

				<div
					class="slide-in-out-reverse delay-4 absolute -top-[0px] z-20 w-full md:left-[90px] md:top-[140px]"
				>
					<div
						class="h-[280px] w-[40px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00BBFF] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>
			</div>

			<div
				class="right-side absolute -right-[50px] top-[100px] h-full md:right-0 md:top-0"
			>
				<div
					class="slide-in-out-reverse delay-6 absolute right-[0px] top-[90px]"
				>
					<div
						class="h-[280px] w-[300px] -skew-x-[20deg] transform bg-gradient-to-b from-[#00375F] to-transparent [mask-image:linear-gradient(to_bottom,transparent,black_20%,black_80%,transparent)]"
					/>
				</div>
			</div>

			<button
				class="absolute left-0 top-0 z-20 h-full w-full"
				@click="handleBannerClick"
			/>

			<div
				class="flex h-full w-full flex-col items-center justify-between gap-2 px-4 py-4 md:flex-row md:gap-4 lg:justify-center lg:gap-8"
			>
				<div class="pointer-events-none relative z-10 flex">
					<CarbarImage
						image="img/campaigns/september-new-bonus-2026/img-car.webp"
						alt-text="Chery Tiggo"
						image-width-class="w-auto"
						image-height-class="h-[120px] sm:h-[130px] md:h-[280px] lg:h-[140px] xl:h-[150px]"
						class="delay-1 slide-in-right relative object-contain"
						:preload="true"
					/>
				</div>
				<div class="flex w-auto flex-col items-center gap-1">
					<div
						class="relative flex w-full flex-col items-center gap-1 md:items-start"
					>
						<div
							class="slide-up delay-1 flex text-xl font-medium leading-none text-white"
						>
							1 September - 16 October 2026
						</div>
						<div
							class="slide-up delay-2 text-center font-heading text-[1.5rem] font-bold leading-tight text-white md:text-left md:text-[1.8rem] md:leading-none lg:text-[2rem] xl:text-[2.3rem]"
						>
							New Subscriber Bonus,
							<br class="hidden lg:block" />
							Half the Upfront Fee
						</div>
					</div>
				</div>

				<!-- Cta & Promocode -->
				<div
					class="slide-in-right delay-3 z-30 flex w-fit min-w-[150px] flex-col"
				>
					<div
						class="z-30 flex w-full flex-col rounded-t-lg bg-white px-4 py-2 lg:px-4 lg:py-3"
					>
						<span
							class="font-body text-xsm uppercase text-[#00375F]"
						>
							PROMO CODE:
						</span>
						<div class="place-items-star grid">
							<Transition name="fade" mode="out-in">
								<span
									v-if="promocode"
									key="text"
									class="col-start-1 row-start-1 font-heading text-xl font-semibold leading-none tracking-wide text-[#00375F] lg:text-xl"
								>
									{{ promocode }}
								</span>

								<div
									v-else
									key="loader"
									class="col-start-1 row-start-1 flex items-center"
								>
									<ContentLoader
										class="h-[18px] w-20 sm:w-[68px]"
									/>
								</div>
							</Transition>
						</div>
					</div>
					<div
						class="group flex cursor-pointer items-center justify-between rounded-b-lg bg-[#00FFF9] px-4 py-2 text-lg font-medium text-[#00375F] transition-colors duration-300 hover:bg-[#00375F] hover:text-white"
						@click="handleBannerClick"
					>
						Find a car
						<IconArrowRight
							class="group:hover-fill-white h-5 w-5"
						/>
					</div>
				</div>
			</div>

			<TermsAndConditions
				:is-full-width="false"
				custom-class="pb-4 md:pb-0 md:absolute md:right-4 md:bottom-2 lg:bottom-3 z-50"
				font-color="text-white"
			>
				<CarbarLink
					text="Terms & conditions"
					text-color="text-white"
					underline-color="decoration-white"
					hover-color="hover:decoration-[#cccccc] hover:text-[#cccccc]"
					font-size="text-xsm"
					class="cursor-pointer"
					@click="
						goToPageAndScroll(
							'/terms-and-conditions',
							'#september-new-bonus-promo',
							true
						)
					"
				/>
				apply.
			</TermsAndConditions>
		</div>
	</div>
</template>

<script setup lang="ts">
import IconArrowRight from '@/assets/svg/common/ico-arrow-right-menu-small.svg'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const promocode = getPrimaryCampaignPromo()

const { partnerName } = useGetPartnerName()
const { whitelabel } = useWhitelabelsStyles()

const isPartner = !!partnerName.value

const handleBannerClick = async () => {
	const partnerUrl = whitelabel.value?.links?.partnerUrl

	if (isPartner && partnerUrl) {
		await navigateTo(`${partnerUrl}/browse`, { external: true })
	} else {
		await navigateTo('/cars/subscribe', { external: true })
	}
}

const mounted = ref(false)

onMounted(() => {
	setTimeout(() => {
		mounted.value = true
	}, 50)

	document.querySelectorAll('.slide-in-out').forEach((el) => {
		/* eslint-disable-next-line security-node/detect-insecure-randomness */
		const randomDelay = (Math.random() * 1.5).toFixed(2)
		el.style.animationDelay = `${randomDelay}s`
	})
})
</script>

<style lang="scss" scoped>
.slide-in-out {
	position: relative;
	opacity: 0;
	animation: slide-in-out 4s ease-in-out infinite;
}

@keyframes slide-in-out {
	0% {
		/* Starts top-right: shifted up and pushed right along the 20deg axis */
		transform: skewX(-20deg) translate(36.4px, -100px);
		opacity: 0;
	}
	10% {
		/* Settles into resting position */
		transform: skewX(-20deg) translate(0, 0);
		opacity: 1;
	}
	90% {
		/* Subtle downward-left drift during main hold */
		transform: skewX(-20deg) translate(-1.45px, 4px);
		opacity: 1;
	}
	100% {
		/* Exits bottom-left: shifted down and pushed left along the 20deg axis */
		transform: skewX(-20deg) translate(-36.4px, 100px);
		opacity: 0;
	}
}

.slide-in-out-reverse {
	position: relative;
	opacity: 0;
	animation: slide-in-out-reverse 4s ease-in-out infinite;
}

@keyframes slide-in-out-reverse {
	0% {
		/* Starts bottom-left: shifted down and pushed left along the 20deg axis */
		transform: skewX(-20deg) translate(-36.4px, 100px);
		opacity: 0;
	}
	10% {
		/* Settles into resting position */
		transform: skewX(-20deg) translate(0, 0);
		opacity: 1;
	}
	90% {
		/* Subtle upward-right drift during main hold */
		transform: skewX(-20deg) translate(1.45px, -4px);
		opacity: 1;
	}
	100% {
		/* Exits top-right: shifted up and pushed right along the 20deg axis */
		transform: skewX(-20deg) translate(36.4px, -100px);
		opacity: 0;
	}
}

.slide-in-right {
	transform: translateX(30%);
	opacity: 0;
	animation: slide-in 0.5s ease forwards;
}

@keyframes slide-in {
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.slide-up {
	display: inline-block;
	transform: translateY(30px);
	margin-right: 0.35rem;
	opacity: 0;
	animation: slide-up 0.4s ease forwards;
}

@keyframes slide-up {
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

/* Animation delays for each word */
.delay-0 {
	animation-delay: 0s;
}
.delay-1 {
	animation-delay: 0.2s;
}
.delay-2 {
	animation-delay: 0.4s;
}
.delay-3 {
	animation-delay: 0.6s;
}
.delay-4 {
	animation-delay: 0.8s;
}
.delay-5 {
	animation-delay: 1s;
}
.delay-6 {
	animation-delay: 1.2s;
}
</style>
